import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { navigateTo } from "../../redux/router/routerActions"
import { useAppDispatch } from "../../redux/store"
import canAccess from "../../services/accessService/accessService"

const platforms = [
    {
        key: 'vrbo',
        title: 'VRBO',
        description: 'Manage the VRBO integrations and their sync status.',
        to: '/vrbo-integrations',
        action: 'vrbo-integrations',
    },
]

export default function PlatformIntegrationsPage() {

    const dispatch = useAppDispatch()

    const availablePlatforms = platforms.filter(platform => canAccess('routes', platform.action))

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Platform Integrations</h1>
                    <hr />
                    <p>Select a platform to manage its integration settings.</p>
                </Col>
            </Row>
            <Row xs={1} md={2} lg={3} className="g-3">
                {availablePlatforms.map(platform => (
                    <Col key={platform.key}>
                        <Card className="h-100">
                            <Card.Body className="d-flex flex-column">
                                <Card.Title>{platform.title}</Card.Title>
                                <Card.Text>{platform.description}</Card.Text>
                                <Button
                                    className="mt-auto"
                                    variant="primary"
                                    onClick={() => dispatch(navigateTo(platform.to))}
                                >
                                    Manage {platform.title}
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
                {availablePlatforms.length === 0 && (
                    <Col>
                        <p>No platform integrations available.</p>
                    </Col>
                )}
            </Row>
        </Container>
    )
}
